// The new-ticket draft survives a reload (subject and description only — never the application
// password, never files). A browser without storage (private mode, blocked site data) simply skips it.

export interface IHelpdeskDraft {
  subject: string;
  description: string;
}

export function helpdeskDraftKey(userId: string | undefined): string {
  return `kuika:helpdesk:new-ticket-draft:${userId || "anonymous"}`;
}

function storage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function readHelpdeskDraft(key: string, store: Storage | null = storage()): IHelpdeskDraft | null {
  try {
    const saved: string | null = store?.getItem(key) ?? null;
    if (!saved) return null;
    const parsed: Partial<IHelpdeskDraft> = JSON.parse(saved) as Partial<IHelpdeskDraft>;
    const subject: string = typeof parsed.subject === "string" ? parsed.subject : "";
    const description: string = typeof parsed.description === "string" ? parsed.description : "";
    return subject || description ? { subject, description } : null;
  } catch {
    return null;
  }
}

export function writeHelpdeskDraft(key: string, draft: IHelpdeskDraft, store: Storage | null = storage()): void {
  try {
    if (draft.subject || draft.description) {
      store?.setItem(key, JSON.stringify({ subject: draft.subject, description: draft.description }));
    } else {
      store?.removeItem(key);
    }
  } catch {
    // Nothing to do without storage.
  }
}

export function clearHelpdeskDraft(key: string, store: Storage | null = storage()): void {
  try {
    store?.removeItem(key);
  } catch {
    // Nothing to do without storage.
  }
}
